import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";

import {
  Stack,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormLabel,
  Tooltip,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ToggleButton,
  Autocomplete,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PreLoader } from "../../subcomponents/Preloader";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import { phoneTypes } from "../../../constants/PhoneTypes";
import { Languages } from "../../../constants/languages";
import GooglePlacesAutocomplete, {
  Place,
} from "../../subcomponents/GoogleAutocomplete";
import {
  validateEmail,
  validatePhoneNumber,
  validationMessages,
  validationLength,
  validateString,
  validationType,
} from "../../actions/validations";
import {
  converttoDayjsTime,
  converttoStandardTime,
  propertyTime,
} from "../../../constants/PropertyInformation";
import { TutorialComponent } from "../../Tour/DemoTour";
import { RoomPropertyEnum } from "../../../constants/NavbarList";
import { YesOrNo } from "../../../constants/YesOrNo";
import { GolfPropertyTime } from "../../../constants/PropertyInformation";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import InfoIcon from "@mui/icons-material/Info";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DAYS } from "../../../constants/Days";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import {
  checkData,
  deleteItem,
  fillAutocompleteValues,
  updateData,
} from "../../actions/actionItems";
import { GolfPropertyEnum } from "../../../constants/NavbarList";
import AlertComponent from "../../subcomponents/AlertComponent";
import {
  golfTooltipHeaders,
  originsTooltip,
} from "../../../constants/TooltipInformation";
import { removeSampleTestArray } from "../../actions/cleanup";
import { ClearButton } from "../../subcomponents/ClearButton";
import { CopyButton } from "../../subcomponents/CopyButton";

const GolfCancelReasons = ({
  data,
  fieldValues,
}: {
  data: any;
  fieldValues: any;
}) => {
  const [cancelreasons, setCancelreasons] = useState<any>([]);
  const [defaultt, setDefault] = useState<boolean>(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [GolfCancelReasons, setGolfCancelReasons] = useState<any>([]);
  const [cancelreasonsError, setCancelreasonsError] = useState<boolean>(false);
  const [cancelreasonsErrorMessage, setCancelreasonsErrorMessage] =
    useState<string>("");

  const updateGolfCancelReasons = () => {
    if (!cancelreasons || cancelreasons.length === 0) {
      setAlertMessage("Cancel reasons are mandatory");
      setAlertType("error");
      setOpenAlert(true);
      return false;
    }
    setCancelreasonsError(false);
    setCancelreasonsErrorMessage("");
    if (
      cancelreasons &&
      !validateString(
        cancelreasons,
        validationLength.cancelReason,
        validationType.SPACE,
      )
    ) {
      setCancelreasonsError(true);
      setCancelreasonsErrorMessage(validationMessages.cancelReason);
      return false;
    }
    setGolfCancelReasons((prev: any) => {
      return (prev ?? []).map((item: any) => {
        if (item.id === selectedId) {
          return {
            ...item,
            ...payload,
          };
        }
        return item;
      });
    });
    editGolfCancelReasons(null);
    setEditClicked(false);
    setSelectedId(null);
    setAlertMessage(`${GolfPropertyEnum.cancelReasons} updated successfully`);
    setAlertType("success");
    setOpenAlert(true);
  };

  const addGolfCancelReasons = () => {
    if (!cancelreasons || cancelreasons.length === 0) {
      setAlertMessage("Cancel reasons are mandatory");
      setAlertType("error");
      setOpenAlert(true);
      return false;
    }
    setCancelreasonsError(false);
    setCancelreasonsErrorMessage("");
    if (
      cancelreasons &&
      !validateString(
        cancelreasons,
        validationLength.cancelReason,
        validationType.SPACE,
      )
    ) {
      setCancelreasonsError(true);
      setCancelreasonsErrorMessage(validationMessages.cancelReason);
      return false;
    }
    setGolfCancelReasons((prev: any) => {
      return updateData(
        prev != null
          ? [
              ...prev,
              {
                id: (GolfCancelReasons?.length ?? 0) + 1,
                ...payload,
              },
            ]
          : [
              {
                id: 1,
                ...payload,
              },
            ],
      );
    });
    setLastUpdatedRecord(payload);
    editGolfCancelReasons(null);
    setEditClicked(false);
  };

  const editGolfCancelReasons = (list: any) => {
    list?.id && setSelectedId(list.id);
    list !== null && setEditClicked(true);
    setCancelreasons(list?.["Cancel Reasons"]);
    setDefault(list?.["Default"]);
  };

  const deleteGolfCancelReasons = (id: number) => {
    setGolfCancelReasons(deleteItem(GolfCancelReasons ?? [], id));
  };
  useEffect(() => {
    if (fieldValues) {
      setGolfCancelReasons(fieldValues[GolfPropertyEnum.cancelReasons]);
    }
  }, []);

  useEffect(() => {
    data(GolfCancelReasons);
    editClicked &&
      setSelectedId(
        checkData(GolfCancelReasons, selectedId) ? selectedId : null,
      );
  }, [GolfCancelReasons]);

  const payload = {
    "Cancel Reasons": cancelreasons,
    Default: defaultt,
  };
  return (
    <Stack>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
        }}
      >
        <Stack direction="row" width="100%" justifyContent="space-between">
          <Typography variant="h6" component="div" sx={textStyle}>
            Cancel Reasons
            <Tooltip title={tooltipComponent("")}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Typography>
          <Stack direction="row" gap="10px" justifyContent="space-between">
            {editClicked && (
              <ClearButton
                click={() => {
                  editGolfCancelReasons(null);
                  setSelectedId(null);
                }}
              />
            )}
            {lastUpdatedRecord && (
              <CopyButton
                click={() => {
                  editGolfCancelReasons(lastUpdatedRecord);
                }}
              />
            )}
          </Stack>
        </Stack>
        <FormLabel component="legend">
          Cancel Reasons
          <Tooltip title={tooltipComponent(golfTooltipHeaders.minMinutes)}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        </FormLabel>
        <TextField
          id="cancelreasons"
          variant="outlined"
          placeholder="Cancel Reasons"
          value={cancelreasons ?? ""}
          onChange={(e: any) => {
            setCancelreasons(e.target.value);
          }}
          error={cancelreasonsError}
          helperText={cancelreasonsError ? cancelreasonsErrorMessage : ""}
        />
        <Stack direction="row" width="100%" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{
              cursor: "pointer",
              border: "1px solid gray",
              borderRadius: "10px",
              background: "darkgreen",
              color: "white",
            }}
            onClick={() =>
              selectedId ? updateGolfCancelReasons() : addGolfCancelReasons()
            }
          >
            {selectedId ? buttonValues.UPDATE : buttonValues.ADD}
            Cancel Reasons
          </Button>
        </Stack>
        <Stack direction="column" gap="10px" mt={4}>
          <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
            Do not use sample data. Those are for demo purposes only!
          </Typography>
          <Typography variant="h6">Cancel Reasons Available</Typography>
          <Stack direction="column" gap="10px">
            {GolfCancelReasons ? (
              <DraggableItemList
                itemData={GolfCancelReasons}
                onOrderUpdate={(order) => setGolfCancelReasons(order)}
                onEdit={(info) => editGolfCancelReasons(info)}
                onDelete={(id) => deleteGolfCancelReasons(id)}
                code={DNDFieldsEnum.CANCELREASONS}
                name={DNDFieldsEnum.DEFAULT}
              />
            ) : (
              <Typography variant="body2">
                No Allocation Block Information Available
              </Typography>
            )}
          </Stack>
        </Stack>
      </Paper>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};

export default GolfCancelReasons;
